import {sanitizeUrl} from '@braintree/sanitize-url';
import {
  Selectors,
  useWidgetState,
} from '@eCommerce/frontend-legacy-shared-library';
import {useSearchParams} from 'react-router-dom';
import {isAbsoluteUrl} from 'utils/utils';

const authenticatedReturn = '/rewards/profile';
const unauthenticatedReturn = '/rewards/signin';

export const useGetForwardUrl = () => {
  const [searchParams] = useSearchParams();
  const isLoggedIn = useWidgetState(Selectors.isLoggedInSelector);
  const fallbackForwardUrl = isLoggedIn
    ? authenticatedReturn
    : unauthenticatedReturn;

  const forwardUrl = searchParams.get('forwardUrl') ?? fallbackForwardUrl;

  // prevent off-site links
  if (isAbsoluteUrl(forwardUrl)) {
    return fallbackForwardUrl;
  }

  // sanitize for xss
  const sanitized = sanitizeUrl(forwardUrl);
  return sanitized === 'about:blank' ? fallbackForwardUrl : sanitized;
};
